export const CHANGE_HEADER = 'CHANGE_HEADER';